export var FETCH_USER_INFO_ACTION_SAGA = '@service-user/FETCH_USER_INFO_ACTION_SAGA';
export var fetchUserInfoAction = function (payload) { return ({
    type: FETCH_USER_INFO_ACTION_SAGA,
    payload: payload,
}); };
export var SET_USER_INFO = '@service-user/SET_USER_INFO';
export var setUserInfoAction = function (payload) { return ({
    type: SET_USER_INFO,
    payload: payload,
}); };
export var RESET_USER_INFO = '@service-user/RESET_USER_INFO';
export var resetUserInfoAction = function () { return ({
    type: RESET_USER_INFO,
}); };
export var SET_USER_INFO_LOADING_STOP = '@service-user/SET_USER_INFO_LOADING_STOP';
export var setUserInfoLoadingStopAction = function () { return ({
    type: SET_USER_INFO_LOADING_STOP,
}); };
export var SET_USER_INFO_LOADING_START = '@service-user/SET_USER_INFO_LOADING_START';
export var setUserInfoLoadingStartAction = function () { return ({
    type: SET_USER_INFO_LOADING_START,
}); };
export var FETCH_USER_PERMISSIONS_ACTION_SAGA = '@service-user/FETCH_USER_PERMISSIONS_ACTION_SAGA';
export var fetchUserPermissionsAction = function (payload) { return ({
    type: FETCH_USER_PERMISSIONS_ACTION_SAGA,
    payload: payload,
}); };
export var SET_USER_PERMISSIONS_LOADING_STOP = '@service-user/SET_USER_PERMISSIONS_LOADING_STOP';
export var setUserPermissionsLoadingStopAction = function () { return ({
    type: SET_USER_PERMISSIONS_LOADING_STOP,
}); };
export var SET_USER_PERMISSIONS_LOADING_START = '@service-user/SET_USER_PERMISSIONS_LOADING_START';
export var setUserPermissionsLoadingStartAction = function () { return ({
    type: SET_USER_PERMISSIONS_LOADING_START,
}); };
export var SET_USER_PERMISSIONS = '@service-user/SET_USER_PERMISSIONS';
export var setUserPermissionsAction = function (payload) { return ({
    type: SET_USER_PERMISSIONS,
    payload: payload,
}); };
export var SET_USER_DATA_PERMISSIONS = '@service-user/SET_USER_DATA_PERMISSIONS';
export var setUserDataPermissionsAction = function (payload) { return ({
    type: SET_USER_DATA_PERMISSIONS,
    payload: payload,
}); };
export var REFRESH_USER_FEATURES_ACTION_SAGA = '@service-user/REFRESH_USER_FEATURES_ACTION_SAGA';
export var refreshUserFeaturesActionSaga = function (payload) { return ({
    type: REFRESH_USER_FEATURES_ACTION_SAGA,
    payload: payload,
}); };
